import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['textarea', 'preview', 'trigger'];
  static values = { text: String };

  // Affiche le commentaire précédent + boutons Confirmer/Annuler
  preview() {
    this._savedValue = this.textareaTarget.value;
    this.previewTarget.classList.remove('hidden');
    this.triggerTarget.classList.add('hidden');
  }

  // Confirme : remplace le contenu du textarea
  confirm() {
    this.textareaTarget.value = this.textValue;
    this.textareaTarget.focus();
    this._hide();
  }

  // Annule : restaure l'état initial
  cancel() {
    this.textareaTarget.value = this._savedValue ?? this.textareaTarget.value;
    this._hide();
  }

  _hide() {
    this.previewTarget.classList.add('hidden');
    this.triggerTarget.classList.remove('hidden');
  }
}
